import React from 'react'
import { Breadcrumb } from 'semantic-ui-react';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import { dispatch } from '@rematch/core';
import _ from 'lodash'
import convertCamelCase from '../../../../../helpers/convert-camel-case'


class BreadCrumbsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPracticeLibrary: {},
            selectedPracticeFlowActivity: {}

        }
        this.navigateTo = this.navigateTo.bind(this)
    }

    navigateTo(path) {
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb${path}`
        });
        dispatch.lifeCycle.showResourecePane(null);
        dispatch.lifeCycle.setArrangementPaneFlag(false);
        dispatch.lifeCycle.setSelectedPracticeLibrary({});
    }

    componentWillReceiveProps(newProps) {
        if (this.props.selectedPracticeLibrary !== newProps.selectedPracticeLibrary) {
            this.setState({ selectedPracticeLibrary: newProps.selectedPracticeLibrary })
        }

        if (this.props.selectedPracticeFlowActivity !== newProps.selectedPracticeFlowActivity) {
            this.setState({ selectedPracticeFlowActivity: newProps.selectedPracticeFlowActivity })
        }
    }


    render() {

        const { selectedPracticeLibrary, selectedPracticeFlowActivity } = this.state

        let allCategories = _.unionBy(this.props.categoryTree, this.props.categoryPublicTree, "_id");
        let bc = allCategories.filter((b, i) => { return b._id === this.props.routeParams.baseCategory })[0]
        let cat = bc && bc.nodes && bc.nodes.filter((c, i) => { return c._id === this.props.routeParams.category })[0]
        let sub = cat && cat.nodes && cat.nodes.filter((sc, i) => { return sc._id === this.props.routeParams.subCategory })[0]


        let setStatus = [];

        let pushStatus = this.props.routeParams.status === "knowledgeBank" || this.props.routeParams.status === "publicKnowledgeBank" ?
            null : setStatus.push({ bcItem: this.props.routeParams.status })
        if (this.props.routeParams.subCategory) {
            pushStatus
            setStatus.push({ bcItem: bc && bc.name ? bc.name : "NA" ,path: `${this.props.routeParams.status}/${this.props.routeParams.baseCategory}`})
            setStatus.push({ bcItem: cat && cat.name ? cat.name : "NA" ,path: `${this.props.routeParams.status}/${this.props.routeParams.baseCategory}/${this.props.routeParams.category}`})
            setStatus.push({ bcItem: sub && sub.name ? sub.name : "NA" ,path: `${this.props.routeParams.status}/${this.props.routeParams.baseCategory}/${this.props.routeParams.category}/${this.props.routeParams.subCategory}`})
        } else if (this.props.routeParams.category) {
            pushStatus
            setStatus.push({ bcItem: bc && bc.name ? bc.name : "NA" ,path: `${this.props.routeParams.status}/${this.props.routeParams.baseCategory}`})
            setStatus.push({ bcItem: cat && cat.name ? cat.name : "NA" ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}/${this.props.routeParams.category}`})
        } else if (this.props.routeParams.baseCategory) {
            pushStatus
            setStatus.push({ bcItem: bc && bc.name ? bc.name : "NA" ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}`})
        } else {
            pushStatus
        }
        // In Design = 0,  In-Review  = 1,  Approved = 2,  Rejected=3, Published=4, Deprecated=5, Clone / Purchased = 6, Generating = -1 
        let stringStatus = selectedPracticeLibrary && selectedPracticeLibrary.status === 0 ? "In Design" :
            selectedPracticeLibrary.status === 1 ? "Review request" :
                selectedPracticeLibrary.status === 2 ? "Approved" :
                    selectedPracticeLibrary.status === 3 ? "Rejected" :
                        selectedPracticeLibrary.status === 4 ? "Published" :
                            selectedPracticeLibrary.status === 5 ? "Inactive" :
                                selectedPracticeLibrary.status === -1 ? "Generating":
                                    selectedPracticeLibrary.status === 6 ? "Clone" : null


        if (selectedPracticeLibrary && !_.isEmpty(selectedPracticeLibrary)) {
            setStatus = []
            if (stringStatus) {
                setStatus.push({ bcItem: stringStatus , path: stringStatus})
            }
            setStatus.push({ bcItem: selectedPracticeLibrary.name})
        }

        // if (!_.isEmpty(selectedPracticeFlowActivity)) {
        //     setStatus = []
        //     if (stringStatus) {
        //         setStatus.push({ bcItem: stringStatus })
        //     }
        //     setStatus.push({ bcItem: selectedPracticeLibrary.name })
        //     setStatus.push({ bcItem: selectedPracticeFlowActivity.name })
        // }

        let status = setStatus &&
            setStatus.length !== 0 &&
            setStatus.filter((item, i) => { return item.bcItem !== 'knowledgeBank' && item.bcItem !== 'playbookLibrary' })
                .map((item, i) => {
                    let replaceName =
                        item.bcItem === "underReview" ? "Review request" :
                            item.bcItem === "inReview" ? "Sent" :
                                item.bcItem === "forReview" ? "Received" :
                                    item.bcItem
                    return item.bcItem ? <span key={i}>
                        <Breadcrumb.Divider icon='right angle' />
                        <Breadcrumb.Section onClick={()=>{if(item.path){this.navigateTo(`/status/${item.path}`)}}} style={{ cursor: item.path ? 'pointer' : 'default', color: item.path ? "#4183c4" : "black" }}>
                            <EllipsisTooltip
                                name={replaceName}
                                position="bottom left"
                            />
                        </Breadcrumb.Section>
                    </span> : null
                })

        return <Breadcrumb className="breadCrumbs w_100" >
            {this.props.match.params.status && this.props.match.params.status === 'knowledgeBank' && !this.props.match.params.baseCategory ?
                <Breadcrumb.Section>Workspace Library</Breadcrumb.Section> :
            this.props.match.params.status && this.props.match.params.status === 'knowledgeBank' ?
                <Breadcrumb.Section onClick={()=>{this.navigateTo("/status/knowledgeBank")}}>Workspace Library</Breadcrumb.Section>
                :this.props.match.params.status && this.props.match.params.status === 'publicKnowledgeBank' && !this.props.match.params.baseCategory ?
                  <Breadcrumb.Section>Public Library</Breadcrumb.Section>
                   :this.props.match.params.status && this.props.match.params.status === 'publicKnowledgeBank' ?
                    <Breadcrumb.Section onClick={()=>{this.navigateTo("/status/publicKnowledgeBank")}}>Public Library</Breadcrumb.Section>
                    :(this.props.match.params.status && this.props.match.params.status !== "playbookLibrary") || (this.props.selectedPracticeLibrary && !_.isEmpty(selectedPracticeLibrary))? 
                    <Breadcrumb.Section onClick={()=>{this.navigateTo("")}}>{this.props.practiceLabelName} Library  </Breadcrumb.Section>
                    :<Breadcrumb.Section>{this.props.practiceLabelName} Library  </Breadcrumb.Section>
            }
           {this.props.match.params.status && this.props.match.params.status === "knowledgeBank" &&
            this.props.routeParams.status !== "In Design" &&
             this.props.routeParams.status !== "Approved" &&
              this.props.routeParams.status !== "Published" &&
               this.props.routeParams.status !== "underReview" &&
                this.props.routeParams.status !== "inReview" &&
                this.props.routeParams.status !== "Generating" &&
                 this.props.routeParams.status !== "forReview" &&
                  this.props.routeParams.status !== "Inactive" ? status : ""}
           {this.props.match.params.status && this.props.match.params.status !== "knowledgeBank" ? status :""}
           {!this.props.match.params.status ? status :""}

        </Breadcrumb>
    }
}


export default BreadCrumbsPage;